function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * IDE Messenger와의 통신을 위한 EditorContent 생성 함수
 */ export var createEditorContent = function(code, title, language) {
    return {
        type: "doc",
        content: [
            {
                type: "educationBlock",
                attrs: {
                    title: title,
                    content: "```".concat(language, "\n").concat(code.replace(/`/g, '\\`'), "\n```"),
                    category: title.includes('Selected') ? 'Selected Code' : 'Code Snippet',
                    markdown: "```".concat(language, "\n").concat(code.replace(/`/g, '\\`'), "\n```")
                }
            }
        ]
    };
};
/**
 * 클립보드 복사 핸들러
 */ export var createCopyHandler = function(codeString, setIsCopied) {
    return /*#__PURE__*/ _async_to_generator(function() {
        var err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        navigator.clipboard.writeText(codeString)
                    ];
                case 1:
                    _state.sent();
                    setIsCopied(true);
                    setTimeout(function() {
                        return setIsCopied(false);
                    }, 2000);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error('Failed to copy code:', err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
/**
 * 선택된 텍스트를 채팅에 전송하는 핸들러
 */ export var createPasteSelectedTextToChatHandler = function(ideMessenger, language, setSelectedText, setSelectionPosition) {
    return function(selectedCode) {
        var _window_getSelection;
        if (!ideMessenger || !selectedCode) {
            console.warn("IDE Messenger context is not available or no text selected.");
            return;
        }
        var editorContent = createEditorContent(selectedCode, "Selected Code Snippet (".concat(language.toUpperCase(), ")"), language);
        try {
            ideMessenger === null || ideMessenger === void 0 ? void 0 : ideMessenger.post('addEducationContextToChat', {
                content: editorContent,
                shouldRun: false,
                prompt: ""
            });
        } catch (error) {
            console.error('Failed to send selected code to chat:', error);
        }
        setSelectedText(null);
        setSelectionPosition(null);
        (_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.removeAllRanges();
    };
};
/**
 * 전체 코드를 채팅에 전송하는 핸들러
 */ export var createPasteToChatHandler = function(ideMessenger, codeString, language) {
    return function() {
        if (!ideMessenger) {
            console.warn("IDE Messenger context is not available.");
            return;
        }
        var editorContent = createEditorContent(codeString, "Code Snippet (".concat(language.toUpperCase(), ")"), language);
        try {
            ideMessenger === null || ideMessenger === void 0 ? void 0 : ideMessenger.post('addEducationContextToChat', {
                content: editorContent,
                shouldRun: false,
                prompt: ""
            });
        } catch (error) {
            console.error('Failed to send code to chat:', error);
        }
    };
};
/**
 * 에디터에 실습 파일을 생성하는 핸들러
 */ export var createPasteToEditorHandler = function(ideMessenger, language, codeString) {
    return function() {
        if (!ideMessenger) {
            console.warn("IDE Messenger context is not available.");
            return;
        }
        try {
            ideMessenger === null || ideMessenger === void 0 ? void 0 : ideMessenger.post('createPracticeFile', {
                language: language,
                code: codeString
            });
        } catch (error) {
            console.error('Failed to create practice file:', error);
        }
    };
};
/**
 * 마우스 업 이벤트 핸들러 (텍스트 선택 감지)
 */ export var createMouseUpHandler = function(codeContainerRef, setSelectedText, setSelectionPosition) {
    return function(event) {
        var selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
            var selectedString = selection.toString();
            var codeBlockNode = codeContainerRef.current;
            if (selectedString && codeBlockNode && selection.anchorNode && codeBlockNode.contains(selection.anchorNode)) {
                setSelectedText(selectedString);
                var range = selection.getRangeAt(0);
                var rect = range.getBoundingClientRect();
                var containerRect = codeBlockNode.getBoundingClientRect();
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                setSelectionPosition({
                    top: rect.bottom - containerRect.top + scrollTop + 5,
                    left: rect.right - containerRect.left + scrollLeft - 50
                });
            } else {
                setSelectedText(null);
                setSelectionPosition(null);
            }
        } else {
            setSelectedText(null);
            setSelectionPosition(null);
        }
    };
};
